import { Link } from './link.model';


export class CompanyLink {
  id: number | string;
  link: Link;
  active: boolean;
  isValid: boolean;
  hrefValue: string;
  order: number;
  label?: string;

  constructor (link: any = {}) {
    this.active = link.active || false;
    this.id = link.id || null;
    this.isValid = link.isValid || false;
    this.link = link.link || new Link();
    this.hrefValue = link.hrefValue || null;
    this.order = link.order || null;
    this.label = link.label || '';
  }
}
